import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Creators } from '../../../duck/actions';
import AdBanner from '../../common/AdBanner/AdBanner';
import OuterBox from '../../common/OuterBox/OuterBox';
import InnerBox from '../../common/InnerBox/InnerBox';
import SideBar from '../../common/SideBar/SideBar';
import {
  ListElement,
  Title,
  // StyledLine,
  // StyledLineInside,
  Content,
  AuthorAndTime,
  Image,
  FlexContainer
} from '../../common/StyledComponents';
import RelatedArticles from '../../common/RelatedArticles/RelatedArticles';
import Breadcrumb from '../../common/Breadcrumb/Breadcrumb';
import { isVisible, createMarkup } from '../../../utils/utils';
import Comments from '../../common/Comments/Comments';
import adTissot from '../../../assets/images/ad-tissot.png';
import adSuggested from '../../../assets/images/ad-suggested.png';
import adSeparator from '../../../assets/images/ad-separator.png';
import StickyHeader from '../../common/Navigation/StickyHeader/StickyHeader';
// import { rootConfig } from '../../../config/config';

class SingleNews extends Component {
  state = {
    height: [],
    newsElementsArr: [],
    elementIndex: 0,
    upperBound: 0,
    lowerBound: null
  };

  componentWillMount = () => {
    // console.log('[SingleNews.js] componentWillMount');
    // window.scrollTo(0, 0);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.changeUrl);
  };

  componentDidMount = () => {
    // console.log('CDM: ');
    // console.log('[SingleNews.js]\n[CDM]\nthis.props: ', this.props);
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.changeUrl);

    let postSlug = this.props.location.pathname.slice(1);

    this.props.onFetchSingleNews(postSlug);

    if (this.props.topNews === null) {
      this.props.onFetchTopNews();
    }
    // let slugInUrl = this.props.singleNews;
    // let result = slugInUrl[slugInUrl.length - 1];
    // if (result) console.log('[CDM] result: ', result.slug);
    // console.log('[CDM] slugInUrl: ', slugInUrl[slugInUrl.length - 1].slug);
    // this.props.history.push();

    /* _____________________________________________________ */
    // let slugsArr = [],
    //   height = [],
    //   newsElementsArr = [];
    // for (let index in this.props.singleNews) {
    //   newsElementsArr[index] = document.getElementById(
    //     `${this.props.singleNews[index].slug}`
    //   );
    //   // slugsArr[index] = newsElementsArr[index].id;
    //   height[index] = newsElementsArr[index].offsetHeight;
    // }
    // console.log('newsElementsArr: ', newsElementsArr);
    // console.log('slugsArr: ', slugsArr);
    // console.log('height: ', height);

    // let // elementIndex = 0,
    // upperBound = 0,
    // lowerBound = height[0];
    // console.log('CDM');
    // this.setState({ height: height, newsElementsArr: newsElementsArr });
    window.twttr.widgets.load();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.location.state === 'change') {
      window.scrollTo(0, 0);
    }
    // console.log('prevProps: ', prevProps);
    // console.log('CDUp: ');
    window.twttr.widgets.load();
    // console.log('prevProps: ', prevProps);

    // console.log('postSlug: ', postSlug);
    // console.log(
    //   'prevProps.location.pathname.slice(1): ',
    //   prevProps.location.pathname.slice(1)
    // );
    if (
      prevProps.history.location.state === 'change' &&
      prevProps.history.location.pathname !== prevProps.location.pathname
    ) {
      let postSlug = prevProps.history.location.pathname.slice(1);
      this.props.onFetchSingleNews(postSlug);
      // setTimeout(() => {
      //   console.log('Timeout');
      //   window.scrollTo(0, 0);
      // }, 2000);
    }

    // let slugInUrl = this.props.singleNews;
    // let result = slugInUrl[slugInUrl.length - 1];
    // if (result) console.log('[CDUp] result: ', result.slug);
    // console.log('[SingleNews.js]\n[CDUp]\nthis.props: ', this.props);
    // console.log('[SingleNews.js]\n[CDUp]\nprevProps: ', prevProps);
    // console.log('[SingleNews.js]\n[CDUp]\nprevState: ', prevState);
    // let postSlug = this.props.location.pathname.slice(1);
    // console.log('[CDUp]\npostSlug: ', postSlug);
    // let oldPostSlug = prevProps.location.pathname.slice(1);
    // console.log('[CDUp]\noldPostSlug: ', oldPostSlug);
    // if (postSlug !== oldPostSlug) {
    //   console.log('\n\n*****\n\nTrue\n\n*****\n\n');
    //   window.scrollTo(0, 0);
    //   this.props.onFetchSingleNews(postSlug);
    //   if (this.props.topNews === null) {
    //     this.props.onFetchTopNews();
    //   }
    // }
    // console.log(' singleNews: ',  singleNews);
    let // slugsArr = [],
      height = [],
      newsElementsArr = [];
    for (let index in this.props.singleNews) {
      newsElementsArr[index] = document.getElementById(
        `${this.props.singleNews[index].slug}`
      );
      // slugsArr[index] = newsElementsArr[index].id;
      height[index] = newsElementsArr[index].offsetHeight;
    }
    // if (this.props.singleNews === prevProps.singleNews) return;

    // console.log('newsElementsArr: ', newsElementsArr);
    // console.log('height: ', height);
    // console.log('slugsArr: ', slugsArr);

    // let // elementIndex = 0,
    // upperBound = 0,
    // lowerBound = height[0];

    // console.log('prevState: ', prevState);
    // console.log('state: ', this.state);

    // console.log('this.props.singleNews: ', this.props.singleNews);
    // console.log('this.prevProps.singleNews: ', this.prevProps.singleNews);
    // console.log('CDUp');
    if (prevState.newsElementsArr.length === newsElementsArr.length) return;
    if (newsElementsArr.length && height.length) {
      // console.log('height.length: ', height.length);
      // console.log('newsElementsArr.length: ', newsElementsArr.length);
      this.setState(
        {
          height: height,
          newsElementsArr: newsElementsArr
        }
        // ,
        // () => {
        //   console.log(height, newsElementsArr);
        // }
        // () => this.changeUrl
      );
      // console.log('--------------------- this.state: ', this.state);
    }
  };

  contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    e.preventDefault();
    e.stopPropagation();

    if (targetLink.hostname === window.location.hostname) {
      // This is an Internal Link
      let x = targetLink.pathname;
      if (x.slice(-1) === '/') {
        x = x.slice(0, -1);
      }
      this.props.history.replace({ pathname: x, state: `change` });
    } else {
      // This is an External Link
      window.open(targetLink.href, '_blank');
    }

    console.log('targetLink.protocol: ', targetLink.protocol);
    console.log('targetLink.host: ', targetLink.host);
    console.log('targetLink.hostname: ', targetLink.hostname);
    console.log('targetLink.port: ', targetLink.port);
    console.log('targetLink.pathname: ', targetLink.pathname);
    console.log('targetLink.hash: ', targetLink.hash);
    console.log('targetLink.search: ', targetLink.search);
  };

  changeUrl = () => {
    // console.log('this.state: ', this.state);
    // console.log(
    //   'this.state.newsElementsArr[this.state.elementIndex].id: ',
    //   this.state.newsElementsArr[this.state.elementIndex].id
    // );
    let url = this.props.match.params.slug;

    if (
      this.state.newsElementsArr &&
      this.state.newsElementsArr[this.state.elementIndex]
    ) {
      url = this.state.newsElementsArr[this.state.elementIndex].id;
    }

    if (this.props.match.params.slug !== url) {
      this.props.history.replace(url);
    }
    // console.log('this.props: ', this.props);
    // Handle URL for Infinite Scrolling
    // let slugsArr = [],
    //   height = [],
    //   newsElementsArr = [];
    // for (let index in this.props.singleNews) {
    //   newsElementsArr[index] = document.getElementById(
    //     `${this.props.singleNews[index].slug}`
    //   );
    //   // slugsArr[index] = newsElementsArr[index].id;
    //   height[index] = newsElementsArr[index].offsetHeight;
    // }
    // // console.log('newsElementsArr: ', newsElementsArr);
    // // console.log('slugsArr: ', slugsArr);
    // // console.log('height: ', height);

    // let elementIndex = 0,
    //   upperBound = 0,
    //   lowerBound = height[0];
    // console.log('this.state: ', this.state);
    const { elementIndex, height, upperBound, lowerBound } = this.state;
    let LB = lowerBound === null ? height[0] : lowerBound;
    let UB = upperBound === null ? height[0] : upperBound;
    // if (window.scrollY > upperBound && window.scrollY < LB) {
    //   return;
    // }
    if (window.scrollY > LB) {
      // console.log('window.scrollY: ', window.scrollY);
      // console.log('lowerBound: ', LB);
      // console.log('elementIndex + 1: ', elementIndex + 1);
      // console.log(
      //   'height.slice(0, elementIndex + 1): ',
      //   height.slice(0, elementIndex + 2)
      // );
      UB = LB;
      LB = height.slice(0, elementIndex + 2).reduce((a, b) => a + b, 0);
      // console.log('LB: ', LB);

      // upperBound = lowerBound;

      // this.setState(prevState => {
      //   console.log('prevState: ', prevState);
      //   return {
      //     upperBound: prevState.lowerBound,
      //     lowerBound: prevState.height[prevState.elementIndex + 1]
      //       ? prevState.height[prevState.elementIndex] +
      //         prevState.height[prevState.elementIndex + 1]
      //       : prevState.height[prevState.elementIndex],
      //     elementIndex: prevState.elementIndex + 1
      //   };
      // });
      this.setState(prevState => {
        // console.log(
        //   ' ******************************************** ******************************************** '
        // );
        // console.log('LB: ', LB);
        // console.log('prevState.lowerBound: ', prevState.lowerBound);
        // console.log(
        //   ' ******************************************** ******************************************** '
        // );
        if (UB === prevState.upperBound) return;
        // if (LB === prevState.lowerBound) return;
        // console.log('\n\n\nthis.state: ', this.state);
        // console.log('prevState: ', prevState);
        // console.log('\n\n\n\n');
        return {
          upperBound: UB,
          lowerBound: prevState.height
            .slice(0, prevState.elementIndex + 2)
            .reduce((a, b) => a + b, 0),
          // lowerBound: prevState.height.reduce((a, b) => a + b, 0),
          elementIndex: prevState.elementIndex + 1
        };
      });
    }
    // console.log('window.scrollY: ', window.scrollY);
    // console.log('upperBound: ', UB);
    // console.log('lowerbound: ', LB);
    // console.log('elementIndex: ', elementIndex);
    if (window.scrollY < UB) {
      LB = UB;
      UB =
        elementIndex === 1
          ? 0
          : // : elementIndex === 1
            //   ? height[0]
            height.slice(0, elementIndex - 1).reduce((a, b) => a + b, 0);

      this.setState(prevState => {
        // console.log(
        //   ' ******************************************** ******************************************** '
        // );
        // console.log('elementIndex: ', elementIndex);
        // console.log('LB: ', LB);
        // console.log('UB: ', UB);
        // console.log('prevState: ', prevState);
        // console.log(
        //   ' ******************************************** ******************************************** '
        // );
        if (UB === prevState.upperBound) return;
        return {
          lowerBound: LB,
          upperBound:
            elementIndex === 1
              ? 0
              : // : elementIndex === 1
                //   ? height[0]
                height.slice(0, elementIndex - 1).reduce((a, b) => a + b, 0),
          elementIndex: prevState.elementIndex - 1
        };
      });
      // this.setState(prevState => {
      //   console.log('prevState: ', prevState);
      //   return {
      //     lowerBound: prevState.upperBound,
      //     upperBound: prevState.height[prevState.elementIndex - 1]
      //       ? prevState.height[prevState.elementIndex] -
      //         prevState.height[prevState.elementIndex - 1]
      //       : prevState.height[prevState.elementIndex],
      //     elementIndex: prevState.elementIndex - 1
      //   };
      // });
    }
    // console.log(' ***** ***** ***** ');
    // console.log(' ***** ***** ***** ');
    // console.log('elementIndex: ', elementIndex);
    // console.log('this.state: ', this.state);
    // console.log(' ***** ***** ***** ');
  };

  render() {
    const {
      topNews,
      singleNews,
      relatedArticles,
      tagsList,
      error,
      loading,
      onFetchSingleNews
    } = this.props;
    let timeStamp;

    // console.log('relatedArticles: ', relatedArticles);
    // console.log('tagsList: ', tagsList);
    // /* _____________________________________________________ */
    // let slugsArr = [],
    //   height = [],
    //   newsElementsArr = [];
    // for (let index in this.props.singleNews) {
    //   newsElementsArr[index] = document.getElementById(
    //     `${this.props.singleNews[index].slug}`
    //   );
    //   // slugsArr[index] = newsElementsArr[index].id;
    //   height[index] = newsElementsArr[index].offsetHeight;
    // }
    // // console.log('newsElementsArr: ', newsElementsArr);
    // // console.log('slugsArr: ', slugsArr);
    // // console.log('height: ', height);

    // // let // elementIndex = 0,
    // // upperBound = 0,
    // // lowerBound = height[0];

    // this.setState({ height: height, newsElementsArr: newsElementsArr });

    // this.changeUrl();

    /* _____________________________________________________ */

    // Binding our scroll event handler
    window.onscroll = () => {
      // this.changeUrl();
      // let page = document.getElementById('SingleNews');

      // Fetch another SingleNews when current SingleNews reaches end.
      let ele = document.getElementById('finalAd');
      // console.log('Inside window.onscroll');
      if (ele !== null && isVisible(ele)) {
        if (error || loading) return;
        // console.log('Inside If *******');
        onFetchSingleNews(null, timeStamp);
      }

      // console.log('ele: ', ele);
      // Show/Hide SingleNews Header on scroll down/up.
      let header = document.getElementById('Header');
      if (ele && window.scrollY > window.oldScroll && window.scrollY > 90) {
        header.classList.add('slide-out');
        header.classList.remove('slide-in');
      } else if (ele && window.scrollY < window.oldScroll) {
        header.classList.add('slide-in');
        header.classList.remove('slide-out');
      }
      window.oldScroll = window.scrollY;
    };

    // console.log('\n[SingleNews render]\nthis.props: ', this.props);

    let singlenews = null;
    if (singleNews) {
      singlenews = singleNews.map((news, index) => {
        // console.log('news: ', news);
        timeStamp = news.date;
        return (
          <div key={index} className="SingleNews" id={news.slug}>
            <AdBanner height="250px" width="970px" margin="18px 0">
              <Image
                src={adTissot}
                width="100%"
                height="100%"
                alt="tissot ad"
              />
            </AdBanner>

            <OuterBox>
              <InnerBox direction="column">
                {news && news.bread_crumb ? (
                  <Breadcrumb crumb={news.bread_crumb[0]} />
                ) : null}
                <ListElement className="w-100" maxwidth="100%" padding="0">
                  {/* Title */}
                  {news !== null && Object.keys(news).length ? (
                    <Title
                      className="Title"
                      fontFamily="Nunito"
                      fontSize="3rem"
                      fontWeight="bold"
                      padding="0"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        news.title.rendered
                      )}
                    />
                  ) : null}

                  {/* SubTitle */}
                  {news !== null && Object.keys(news).length ? (
                    <Title
                      className="SubTitle"
                      fontFamily="Montserrat"
                      fontSize="1.25rem"
                      padding="0"
                      fontStyle="italic"
                      lineheight="normal"
                      letterSpacing="0.3px"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        news.excerpt.rendered
                      )}
                    />
                  ) : null}
                </ListElement>
              </InnerBox>
            </OuterBox>

            <OuterBox>
              <InnerBox>
                <ListElement padding="0px 5px 18px 5px">
                  <FlexContainer
                    alignitems="center"
                    className="AuthorImage AuthorImage PostDateTime Comments pb3"
                  >
                    <Image
                      width="31px"
                      height="31px"
                      borderradius="50%"
                      src={news._embedded.author[0].avatar_urls[96]}
                      alt={news.user_meta.authorName}
                    />
                    <AuthorAndTime
                      fontFamily="Nunito"
                      // fontWeight="bold"
                      color="#757575"
                      lineHeight="normal"
                      padding="0 0 0 10px"
                      className="w-100"
                    >
                      <Link to={`author/${news._embedded.author[0].slug}`}>
                        {news.user_meta.authorName}
                      </Link>
                      <span>{news.user_meta.postDate}</span>

                      {/* <div>{ news.authorName}</div> */}
                      {/* <div>{ news.authorName}</div> */}
                    </AuthorAndTime>
                  </FlexContainer>
                  {/* Content */}
                  <Image
                    className="mb3"
                    // src={`${rootConfig.imagesRoot}/${news.fimg_url}`}
                    src={`${news.fimg_url}`}
                    alt={news.slug}
                  />
                  {news && Object.keys(news).length ? (
                    <Content
                      id="content"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        news.content.rendered
                      )}
                    />
                  ) : null}
                  {/* Related Articles */}
                  {relatedArticles[index] && relatedArticles[index].length ? (
                    <RelatedArticles
                      relatedArticlesData={relatedArticles[index]}
                    />
                  ) : null}
                  {/* Tags */}
                  {tagsList[index] && tagsList[index].length
                    ? tagsList[index].map(tag => {
                        // console.log('tag: ', tag);
                        return (
                          <Link
                            key={tag.id}
                            style={{
                              textDecoration: 'none',
                              color: '#757575'
                            }}
                            to={`tags/${tag.tagSlug}`}
                          >
                            <FlexContainer
                              style={{
                                border: '1px solid #979797',
                                display: 'inline-flex',
                                padding: '0.5rem 1rem',
                                margin: '1rem 0.5rem'
                              }}
                            >
                              <Title
                                className="SubTitle"
                                fontFamily="Montserrat"
                                fontSize="0.875rem"
                                // padding="0"
                                fontStyle="italic"
                                lineheight="normal"
                                letterSpacing="0.3px"
                                color="#757575"
                                // onClick={this.contentClickHandler}
                              >
                                {tag.tagTitle}
                              </Title>
                            </FlexContainer>
                          </Link>
                        );
                      })
                    : null}
                  {/* Comments */}
                  {news.user_meta.countNumber > 0 ? (
                    <Comments
                      commentData={{
                        count: news.user_meta.countNumber,
                        author: news._embedded.author,
                        comments: news._embedded.replies
                      }}
                    />
                  ) : null}
                </ListElement>
                <SideBar topNewsData={topNews} />
              </InnerBox>
            </OuterBox>

            <OuterBox>
              <InnerBox>
                <ListElement className="w-100" maxwidth="100%" padding="20px">
                  {/* <Title
                    fontFamily="Montserrat"
                    fontSize="1.5rem"
                    fontWeight="bold"
                  >
                    Suggested
                  </Title>
                  <StyledLine>
                    <StyledLineInside />
                  </StyledLine>
                  <AdBanner height="210px" width="1000px" margin="0" /> */}
                  <AdBanner height="346px" width="1040px" margin="0">
                    <Image
                      src={adSuggested}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                </ListElement>
              </InnerBox>
            </OuterBox>

            <FlexContainer
              className="pv3"
              width="100%"
              // height="145px"
              justifycontent="center"
              alignitems="center"
              style={{ background: '#f1f1f1' }}
            >
              <AdBanner height="91px" width="730px">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </FlexContainer>
          </div>
        );
      });
    }

    // return { singlenews };
    return (
      <Fragment>
        <StickyHeader className="StickyHeader" />
        {singlenews}
        <AdBanner id="finalAd" height="1px" width="970px" margin="0" />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // console.log('\n\n\n[Singlenews] state: ', state.singleNews);
  return {
    topNews: state.news.topNews,
    singleNews: state.singleNews.singleNews,
    relatedArticles: state.singleNews.relatedArticles,
    tagsList: state.singleNews.tagsList,
    error: state.singleNews.error,
    loading: state.singleNews.loading
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchSingleNews: (postSlug, timeStamp) =>
    dispatch(Creators.fetchSingleNews(postSlug, timeStamp)),
  onFetchTopNews: () => dispatch(Creators.fetchTopNews())
  // onFetchRelatedArticles: (tagId, postId) =>
  //   dispatch(Creators.fetchRelatedArticlesForSingleNews(tagId, postId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SingleNews)
);
